<script>
	import { tweened } from "svelte/motion";
	import move from "./move";
	import { onMount } from "svelte";

	let arrow = "<-";
	let arrow2= "->";
	let num = tweened(0);
	let time = new Date();
	$: years = time.getFullYear();
	$: months = time.getMonth();
	$: days = time.getDate();
	$: hours = time.getHours();
	$: minutes = time.getMinutes();
	$: seconds = time.getSeconds();

	onMount(() => {
		const interval = setInterval(() => {
			time = new Date();
		}, 1000);

		return () => {
			clearInterval(interval);
		};
	});
</script>
<svelte:head>
	<title>James Hart</title>
	<html lang="en" />
</svelte:head>
<main>
	<div
		id="container"
		on:click={() => num.set(-198)}
		on:keyup={() => num.set(0)}
		style="{move($num, 1)};"
	>
		<div class="item1">
			<div class="passengers">
				<div class="icon-grid">
					<a
						class="icon-a"
						href="https://www.linkedin.com/in/james-hart-287311289/"
					>
						<img
							class="icon-img"
							src="linkedin-icon2.svg"
							alt="Linkedin"
						/>
					</a>
					<a class="icon-a" href="https://twitter.com/7Jahart">
						<img
							class="icon-img"
							src="twitter-icon.svg"
							alt="Twitter"
						/>
					</a>
					<a class="icon-a" href="mailto:jwehart.7@gmail.com">
						<img
							class="icon-img"
							src="envelope-icon.svg"
							alt="Email"
						/>
					</a>
					<a class="icon-a" href="https://github.com/Gree6">
						<img
							class="icon-img"
							src="github-icon.svg"
							alt="Email"
						/>
					</a>
				</div>

				<div class="path2">
					<svg viewBox="-3.5194 -3.5155 19.76 11.69">
						<path
							d="m 0 0 l 9 0 c 2 0 2 3 0 3 l -9 0 c -2 0 -2 -3 0 -3"
							style="fill: #4dc17a;"
						/>
					</svg>
				</div>
			</div>

			<p class="main-heading">
				<span class="largeJ">J</span>ames
			</p>
			<div style="text-align: center;margin-top:-5%;">
				<p class="arrow" > {arrow2} </p>
			</div>
		</div>
		<div class="item2">
			<h1 class="habout">About</h1>

			<div class="About-Block">
				<p>As seen by the domain and title</p>
				<p>I am <span style="color: #4dc17a;">James</span> a</p>
				<p>
					{(
						seconds +
						minutes * 60 +
						hours * 60 * 60 +
						days * 24 * 60 * 60 +
						months * 30 * 24 * 60 * 60 +
						years * 12 * 30 * 24 * 60 * 60 -
						62340796816
					)
						.toString()
						.replace(/\B(?=(\d{3})+(?!\d))/g, ",") + "'s old"}
				</p>
				<p>with many skills in IT</p>
				<p>
					<span style="color: #4dc17a;">[</span> Python , C# , SQL ,
					Svelte <span style="color: #4dc17a;">]</span>
				</p>
				<p>
					with other skills being developed as we move into the
					future.
				</p>
				<p></p>
				<p>
					Been following the industry since my initial interest in IT.
				</p>
				<p>Interests</p>
				<p>
					<span style="color: #4dc17a;">[</span> GameDev , Math ,
					Security , 3D Printing
					<span style="color: #4dc17a;">]</span>
				</p>
				<div class="arrow_holder">
					<a class="arrow" href="/"> {arrow} </a>
				</div>
			</div>
		</div>
	</div>
</main>

<style>
	:global(body) {
		background-color: black;
		overflow: hidden;
	}

	@font-face {
		font-family: "Lexend SemiBold";
		font-style: normal;
		font-weight: 500;
		src: local("/public/Lexend-SemiBold.ttf") format("tff");
	}

	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	}
	.item1 {
		font-family: "Lexend Semibold";
		grid-row: 1 1;
		margin: 0 0 0 0;
		padding: 0 0 0 0;
	}

	.icon-grid {
		width: 100%;
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.icon-img {
		width: 100%;
		height: 100%;
	}

	.icon-a {
		width: 6vw; /* Adjust width for icons */
		height: 45%; /* Adjust height for icons */
		padding: 2vw;
	}

	.item2 {
		grid-row: 2 2;
		margin: 0 0 0 0;
		padding: 0 0 0 0;
	}

	#container {
		display: grid;
		grid-template-columns: 98vw 98vw;
		min-height: 98vw;
		min-width: 98vw;
		gap: 100vw;
		/* align-items: center; */
		margin: 0 0 0 0;
		padding: 0 0 0 0;
		transition: all 0.5s ease;
		/* transition: left 0.5s ease-in; */
		/*transform-origin: 0 0; */
	}

	/* 	.mobile-container {
	} */

	.passengers {
		margin: 10%;
		/* background: #4dc17a; */
		/*= align-items: center; */
		position: fixed;
		width: 52%;
		height: 13%;
		/*top: 10.5vw;*/
		top: 0.1%;
		left: 25%;
		align-items: center;
		cursor: help;
		border-radius: 5cm;
		z-index: 3;
	}

	.main-heading {
		color: white;
		text-align: center;
		font-size: 20vw;
		margin: 0;
		margin-top: 0rem;
		font-family: Lexend SemiBold;
		user-select: none;
	}

	.largeJ {
		font-size: 35vw;
		cursor: help;
	}

	.habout {
		display: flex;
		justify-content: center;
		font-size: 10vw;
		margin-top: -1%;
		margin-bottom: 2.5%;
		padding-top: 0%;
		color: white;
		text-decoration-line: underline;
		text-decoration-color: #4dc17a;
	}

	.arrow_holder {
		text-align: center;
		margin: 2.5%;
	}

	.arrow {
		text-align: center;
		font-size: large;
		color: white;
		margin-bottom: 2.5%;
		margin-top: 2.5%;
	}

	.path2 {
		position: fixed;
		width: 80%;
		height: 100%;
		top: -3.9%;
		left: 28.6%;
		margin: 0;
		transform: scale(1);
		overflow: visible;
		z-index: -10;
	}

	.About-Block {
		text-align: center;
		color: white;
	}
</style>
